module.exports = __webpack_public_path__ + "img/20240409161627.8b734d06.png";